export const CAMPAIGN_FILTERS = {
  search: '',
  paging: {
    page: 1,
    perPage: 25
  },
  dateRange: {
    startDate: '',
    endDate: ''
  },
  categories: '',
  tags: '',
  folders: '',
  layout: 'table',
  sorting: {
    key: 'activeStatus',
    dir: 'asc'
  }
};
